<template>
  <div class="module-walk-dashboard">
    <div class="dashboard_container">
      <div id="dashboard_semicircle" class="container_semicircle">
        <div class="semicircle_bg" />
        <div id="dashboard_progress" class="semicircle_progress" />
        <div class="semicircle_clip" />
      </div>
      <div class="container_milestone milestone-0">
        <div class="milestone_dot" />
        <div class="milestone_label">
          0
          <span class="label_unit">步</span>
        </div>
      </div>
      <div class="container_milestone milestone-1">
        <div class="milestone_dot dot-1">
          <img
            id="dashboard_flagGreen1"
            class="dot_flag flag-green"
            src="@/pages/cathayfitback/assets/images/landing/flag-green.webp"
          />
        </div>
        <div class="milestone_label">
          <span>300</span>
          <span class="label_unit">億步</span>
        </div>
      </div>
      <div class="container_milestone milestone-2">
        <div class="milestone_dot dot-2">
          <img
            id="dashboard_flagGreen2"
            class="dot_flag flag-green"
            src="@/pages/cathayfitback/assets/images/landing/flag-green.webp"
          />
        </div>
        <div class="milestone_label">
          <span>600</span>
          <span class="label_unit">億步</span>
        </div>
      </div>
      <div class="container_milestone milestone-3">
        <div class="milestone_dot dot-3">
          <img
            id="dashboard_flagGreen3"
            class="dot_flag flag-green"
            src="@/pages/cathayfitback/assets/images/landing/flag-green.webp"
          />
        </div>
        <div class="milestone_label">
          <span>900</span>
          <span class="label_unit">億步</span>
        </div>
      </div>
      <div class="container_milestone milestone-4">
        <div class="milestone_dot dot-4">
          <img
            id="dashboard_flagGray4"
            class="dot_flag flag-gray"
            src="@/pages/cathayfitback/assets/images/landing/flag-gray.webp"
          />
          <img
            id="dashboard_flagGreen4"
            class="dot_flag flag-green"
            src="@/pages/cathayfitback/assets/images/landing/flag-green.webp"
          />
        </div>
        <div class="milestone_label">
          <span>1200</span>
          <span class="label_unit">億步</span>
        </div>
      </div>
      <div id="dashboard_foot" class="container_foot">
        <img
          id="dashboard_footIcon"
          class="foot_icon"
          src="@/pages/cathayfitback/assets/images/landing/marker-foot.svg"
        />
      </div>
      <div id="dashboard_dialog" class="container_target target-4">
        <div class="target_container">
          <img
            class="container_dialog dialog-desktop"
            src="@/pages/cathayfitback/assets/images/landing/dialog-4.svg"
          />
          <img
            class="container_dialog dialog-mobile"
            src="@/pages/cathayfitback/assets/images/landing/dialog-4-s.svg"
          />
          <div class="container_donate">
            <div>公益支持</div>
            <div class="donate_amount">
              1000
              <span class="amount_unit">萬</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Power0 } from "gsap";

export default {
  name: "moduleWalkDashboard",
  props: {
    stepCnt: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShowStep: false,
      target: 120000000000,
      hasAnimated: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateScrollY);
    this.$nextTick(() => {
      this.updateScrollY();
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollY);
  },
  watch: {
    stepCnt(newVal) {
      if (newVal > 0 && this.isShowStep && !this.hasAnimated) {
        this.runStepAnimation();
      }
    }
  },
  methods: {
    updateScrollY() {
      const semicircle = document
        .getElementById("dashboard_semicircle")
        .getBoundingClientRect();
      if (semicircle.top <= window.innerHeight - semicircle.height / 2) {
        if (!this.isShowStep) {
          this.isShowStep = true;
          if (this.stepCnt > 0 && !this.hasAnimated) {
            this.runStepAnimation();
          }
        }
      }
    },
    runStepAnimation() {
      if (this.hasAnimated) return;
      this.hasAnimated = true;

      const progressOffset = 180;

      const progress = document.getElementById("dashboard_progress");
      const flagGreen1 = document.getElementById("dashboard_flagGreen1");
      const flagGreen2 = document.getElementById("dashboard_flagGreen2");
      const flagGreen3 = document.getElementById("dashboard_flagGreen3");
      const flagGray4 = document.getElementById("dashboard_flagGray4");
      const flagGreen4 = document.getElementById("dashboard_flagGreen4");
      const foot = document.getElementById("dashboard_foot");
      const footIcon = document.getElementById("dashboard_footIcon");
      const dialog = document.getElementById("dashboard_dialog");

      const rate = Math.min(this.target, this.stepCnt) / this.target;
      const angle = rate * 180;
      const durance = rate * 3;

      if (angle >= 180) {
        const dialogAnimation8 = this.gsap.timeline();
        dialogAnimation8
          .delay(2.9)
          .to(dialog, 0.05, {
            ease: Power0.easeInOut,
            rotate: 20,
            opacity: 1
          })
          .to(dialog, 0.2, {
            rotate: -20,
            repeat: 1,
            opacity: 1,
            ease: Power0.easeInOut,
            yoyo: true
          })
          .to(dialog, 0.05, {
            ease: Power0.easeInOut,
            rotate: 0,
            opacity: 1
          });
      }

      if (angle >= 45) {
        this.gsap.to(flagGreen1, 0.3, { opacity: 1 }).delay(0.65);
      }

      if (angle >= 90) {
        this.gsap.to(flagGreen2, 0.3, { opacity: 1 }).delay(1.4);
      }

      if (angle >= 135) {
        this.gsap.to(flagGreen3, 0.3, { opacity: 1 }).delay(2.15);
      }

      if (angle >= 180) {
        this.gsap.to(flagGray4, 0.3, { opacity: 0 }).delay(2.9);
        this.gsap.to(flagGreen4, 0.3, { opacity: 1 }).delay(2.9);
      }

      this.gsap.to(progress, durance, {
        ease: Power0.easeNone,
        rotate: angle + progressOffset
      });

      this.gsap.to(foot, durance, {
        ease: Power0.easeNone,
        rotate: angle
      });

      this.gsap.to(footIcon, durance, {
        ease: Power0.easeNone,
        rotate: -angle
      });
    }
  }
};
</script>

<style lang="scss">
.module-walk-dashboard {
  @include margin-x(auto);
  @include padding-x(90px);
  @include padding-top(190px);
  @include padding-bottom(70px);
  width: 100%;
  max-width: 980px;
  position: relative;

  @include media-breakpoint-down("xl") {
    @include padding-x(70px);
    max-width: 740px;
  }

  @include media-breakpoint-down("lg") {
    @include padding-x(100px);
    max-width: 740px;
  }

  @include media-breakpoint-down("sm") {
    @include padding-x(50px);
    @include padding-top(40px);
    max-width: 400px;
  }

  .dashboard_container {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: -1px;
      height: 2px;
      background: white;
      width: 100%;
    }
  }

  .container_semicircle {
    @include padding-bottom(50%);
    position: relative;
    overflow: hidden;
    width: 100%;

    .semicircle_bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #dadcdb;
      clip-path: circle(63% at 50% 100%);
    }

    .semicircle_progress {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      transform: rotate(180deg);
      transform-origin: 50% 100%;

      &:after {
        content: "";
        position: absolute;
        background: #32e18d;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        clip-path: circle(63% at 50% 100%);
      }
    }

    .semicircle_clip {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $color-gray-0;
      clip-path: circle(60% at 50% 100%);
    }
  }

  .container_foot {
    position: relative;
    width: 100%;
    height: 0;
    display: flex;
    align-items: center;
    transform: rotate(0);
    transform-origin: 50% 100%;
    z-index: 1;

    .foot_icon {
      @include margin-left(-23px);
      transform: rotate(0);
      height: 64px;

      @include media-breakpoint-down("xl") {
        @include margin-left(-21px);
        height: 48px;
      }

      @include media-breakpoint-down("sm") {
        @include margin-left(-8px);
        height: 23px;
      }
    }
  }

  .container_milestone {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    .milestone_dot {
      @include margin-x(auto);
      width: 25px;
      height: 25px;
      background: $color-gray-0;
      box-shadow: 1.29517px 2.59033px 5.18066px rgba(24, 52, 45, 0.15),
        0px 5.18066px 20.7226px rgba(112, 130, 119, 0.35);
      border-radius: 20px;
      position: relative;

      .dot_flag {
        position: absolute;
        bottom: 10px;
        left: -40%;
        height: 102px;

        &.flag-gray {
          opacity: 1;
        }

        &.flag-green {
          opacity: 0;
        }

        @include media-breakpoint-down("xl") {
          height: 71px;
        }

        @include media-breakpoint-down("sm") {
          height: 35px;
          bottom: 4px;
          left: -80%;
        }
      }

      @include media-breakpoint-down("xl") {
        width: 18px;
        height: 18px;
      }

      @include media-breakpoint-down("sm") {
        width: 8px;
        height: 8px;
      }
    }

    .milestone_label {
      font-weight: 500;
      font-size: 32px;
      line-height: 142%;
      letter-spacing: 10%;
      position: absolute;
      display: flex;
      align-items: baseline;

      .label_unit {
        white-space: nowrap;
        flex-shrink: 0;
        font-weight: 500;
        font-size: 18px;
        line-height: 125%;
        letter-spacing: 6.5%;
        letter-spacing: 0.065em;
      }

      @include media-breakpoint-down("xl") {
        font-size: 24px;

        .label_unit {
          font-size: 15px;
        }
      }

      @include media-breakpoint-down("sm") {
        font-size: 13px;

        .label_unit {
          font-size: 8px;
        }
      }
    }

    &.milestone-0 {
      left: 0;
      top: calc(100% - 10px);
      transform: translateX(calc(-50% + 10px));

      .milestone_label {
        top: calc(100% + 16px);
      }

      @include media-breakpoint-down("xl") {
        transform: translateX(calc(-50% + 8px));
      }

      @include media-breakpoint-down("sm") {
        top: calc(100% - 5px);
        transform: translateX(calc(-50% + 4px));

        .milestone_label {
          top: calc(100% + 13px);
        }
      }
    }

    &.milestone-1 {
      left: 15.8%;
      top: 27.9%;
      transform: translate(-50%);

      .milestone_label {
        right: calc(100% + 21px);
      }

      @include media-breakpoint-down("sm") {
        .milestone_label {
          top: calc(100% + 6px);
          left: calc(100% - 2px);
        }
      }
    }

    &.milestone-2 {
      left: 50%;
      top: -0.7%;
      transform: translate(-50%);

      .milestone_label {
        top: calc(100% + 18px);
      }

      @include media-breakpoint-down("sm") {
        .milestone_label {
          top: calc(100% + 8px);
        }
      }
    }

    &.milestone-3 {
      left: 84.2%;
      top: 27.9%;
      transform: translate(-50%);

      .milestone_label {
        left: calc(100% + 26px);
      }

      @include media-breakpoint-down("sm") {
        .milestone_label {
          top: calc(100% + 6px);
          right: calc(100%);
          left: unset;
        }
      }
    }

    &.milestone-4 {
      right: 0;
      top: calc(100% - 10px);
      transform: translateX(calc(50% - 10px));

      .milestone_label {
        top: calc(100% + 16px);
      }

      @include media-breakpoint-down("xl") {
        transform: translateX(calc(50% - 8px));
      }

      @include media-breakpoint-down("sm") {
        top: calc(100% - 5px);
        transform: translateX(calc(50% - 4px));

        .milestone_label {
          top: calc(100% + 13px);
        }
      }
    }
  }

  .container_target {
    position: absolute;
    opacity: 0;
    z-index: 1;

    .target_container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .container_dialog {
        filter: drop-shadow(0px 0px 34.6478px rgba(121, 187, 55, 0.05))
          drop-shadow(0px 0px 10.8274px rgba(68, 183, 100, 0.12));

        &.dialog-desktop {
          height: 123px;

          @include media-breakpoint-down("xl") {
            height: 80px;
          }

          @include media-breakpoint-down("sm") {
            display: none;
          }
        }

        &.dialog-mobile {
          @include media-breakpoint-up("sm") {
            display: none;
          }
        }
      }

      .container_donate {
        @include padding-bottom(8px);
        position: absolute;
        text-align: center;
        font-size: 14px;
        margin-top: 6px;
        margin-left: 10px;

        .donate_amount {
          @include margin-top(-8px);
          font-weight: 500;
          font-size: 32px;
          letter-spacing: 0.065em;
          display: flex;
          align-items: baseline;

          .amount_unit {
            font-size: 16px;
          }
        }

        @include media-breakpoint-down("xl") {
          line-height: 170%;
          font-size: 14px;

          .donate_amount {
            font-size: 18px;
          }
        }

        @include media-breakpoint-down("sm") {
          @include padding-bottom(4px);
          font-weight: 500;
          font-size: 10px;
          line-height: 173%;
          letter-spacing: 0%;
          margin-top: 6px;
          margin-left: 0px;

          .donate_amount {
            @include margin-top(-4px);
            font-weight: 500;
            font-size: 14px;
            line-height: 125%;
            letter-spacing: 0%;
            height: 21px;
            display: flex;
            align-items: center;

            .amount_unit {
              font-weight: 500;
              font-size: 14px;
              line-height: 125%;
              letter-spacing: 0%;
            }
          }
        }
      }
    }

    &.target-4 {
      bottom: -11%;
      left: 104%;

      @include media-breakpoint-down("sm") {
        bottom: -23%;
        left: 62%;
      }
    }
  }
}
</style>
